import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Carousel = ({items}) => {
    const [selectedImg, setSelectedImg] = useState(0)
    const [images, setImages] = useState(items)

  // auto play slider
  useEffect(() => {
    setInterval(() => {
      setSelectedImg(selectedImg => selectedImg < images?.length-1 ? selectedImg + 1 : 0 )
    }, 5000)
  },[images?.length])
  console.log(selectedImg)
  console.log(images?.length)

    return (
        <div className="carousel w-full h-full">
          <div  className="carousel-item relative w-full transition duration-600">
        <img alt="" src={images[selectedImg]} className="w-full" />
        <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <Link onClick={()=>{
            selectedImg > 0 ? setSelectedImg(selectedImg - 1)
            :
            setSelectedImg(images?.length -1)
            
            }} className="md:btn md:btn-circle text-3xl text-white">❮</Link> 
          <Link onClick={()=>{
            selectedImg < images?.length -1 ? setSelectedImg(selectedImg + 1)
            :
            setSelectedImg(0)

             }} className="md:btn md:btn-circle text-3xl text-white">❯</Link>
        </div>
      </div> 
      
    </div>
    );
};

export default Carousel;